module.exports = __webpack_public_path__ + "static/img/common.172b4f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/bg/common.jpg
// module id = pvwo
// module chunks = 1